import { z } from 'zod'

import { auditShape } from '@/shared/details'

export * from './paths'

const companySchema = z
  .object({
    id: z.string(),
    name: z.string(),
    externalId: z.string().nullish(),
    description: z.string().nullish(),
    organizationId: z.string(),
    organizationName: z.string(),
    ownerId: z.string().nullish(),
    ownerName: z.string().nullish(),
    isAssignableToUsers: z.boolean(),
    addressLine1: z.string().nullish(),
    addressLine2: z.string().nullish(),
    city: z.string().nullish(),
    state: z.string().nullish(),
    postalCode: z.string().nullish(),
    country: z.string().nullish(),
    email: z.string().nullish(),
    phone: z.string().nullish(),
    phone2: z.string().nullish(),
    fax: z.string().nullish(),
    webSiteUrl: z.string().nullish(),
    customDropdown1: z.string().nullish(),
    customDropdown2: z.string().nullish(),
  })
  .extend(auditShape)

/** A company as its details page and edit form show it. */
export type Company = z.infer<typeof companySchema>

export function parseCompany(body: unknown): Company {
  return companySchema.parse(body)
}

const summarySchema = z.object({
  id: z.string(),
  name: z.string(),
  externalId: z.string().nullish(),
  organizationId: z.string(),
  organizationName: z.string(),
  ownerId: z.string().nullish(),
  ownerName: z.string().nullish(),
  isAssignableToUsers: z.boolean(),
})

/** A company as Find Companies and the chooser show it. */
export type CompanySummary = z.infer<typeof summarySchema>

export function parseCompanySummary(item: unknown): CompanySummary {
  return summarySchema.parse(item)
}
